import script from "./TTipoDeAtividades.vue?vue&type=script&lang=ts&setup=true"
export * from "./TTipoDeAtividades.vue?vue&type=script&lang=ts&setup=true"

import "./TTipoDeAtividades.vue?vue&type=style&index=0&id=0fb13442&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fb13442"]])

export default __exports__